var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#1A73E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48.38,
    height: 49.46,
    transform: "translate(25.8198 25.26)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_110_9148",
    transform: "scale(0.00757576 0.00740741)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_110_9148",
    width: 132,
    height: 135,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIQAAACHCAMAAADgDgE7AAAARVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////9SnXPCAAAAFnRSTlMAgD/AEPCgIOBgMG9QkLDP0I8mSAgUMHqFyQAABJ1JREFUeNrs2N1u4jAQhuEZe8Z/cRw4+e7/UhecpFZA3e5BbVfavgcgQMGPcELiEMk9YEpaPB3JhmnpqVgwsUJ7FhPTn4DAz0MEHpzFO8LS4PgX0Qlh7OelUYiCz+NRCItWsNaG2Qh+IHg6AsAv4kcg+JEBYPjRNARa/ydiRW2fhjYtvRFijGmveMaOGTc8c34eIgecLbMQC9BycxARl9wrwjGz64wQxbuCB5/KI16Lf0csHRAFrwUihi7mk6gDIgCFnbWFmbPhG4BErGnoNSZQiFoSgEgm0WCEef0qHn21naB0KU9BFLpkJiDobUhFHo3wbwiHZTDCB410Ld94GYswxjBdS0Z4LEJWei/msQhyQm8VGozImV4TNxohxdM1fzejEZTKy5g203AE+fU6PwtNQNAqRK0iUxC5UCuuNAVh4JoBPAexAiHuHAeozECIc3i02brZLcYZCDbkcGaFNhmOyBaZKCpqK5GH3v1IhJA9VjvpBkDNuQ6JMgrhnfN4pNWju2afmkLKMgDhHcAGzxIRbcCu0H1bQLk7Iio+ECuR3A5EwokANt8X4YCG2OrZ1NoHhhY0BDT1RKyoFY+af76137+3TVcV/RAZe5baQtvuTwB0ERJGLUgvhCj2AgU8K/tGTGQAJHH2Lgtq3Aux4MgSmcqQE7ECLKF+dMMzlU6IDTgH8PvhkIm0IjZAHJ6Zgxr7IKT9EAsSHcdmPVQFsKSXfZP7IAyONkoslaQVYSnWwS8I2xmB+PGPkXaEAwwPRmBzAbV1RwQo2X9BmIWZ87cgWqEiElAEXyL8XVFTlu9EwADQBWDzFUIcWpq/E1GOB8NfINKfdu1uV3EQCsPwYvFXKLTVcX/3f6ljsptJLLSbMqBmx+fEAw/6hlUpGgc8cPURefrnCK+x4RpGrIRy4wI5wIvcPqEGJC41ERZHpkBxJlLr5dIfGFOiZtuO+Mks5dpg6IFGDtc8RQ1KCXrgkSWrDjUsUcLYZFPMs3VnTBsHHBuEpS2DvLH6yB/MfscSPWVI5JnyiJR1Uert9SfBilaFEfJsRMpzEN+YLR1Bl4hU24iZW7MHEZ7ZJBE9CMKOuF6zf8SiSO7mKf2cCFYT9lzIbSIiuiDGPst4fPRbjR6IS95kWvkFHViLXQO55LhHlk8z2Fj4kTq42eL3FT39pyRipi2HPZbamLFFW2p/Go0gwSce5W0EJETmTKaRGkZqJCIxU0ogFaiVoex2s0hoasWXjtpkptZxGvl5jNiintPIz4P7RQRkiZKVcNTIVLoJKd1tp1LYETIL0WspBHZM29oBKan63ZbpramERo6+2AbTODph/8MG+6Sj/pSbkVO/HMpIlFt8Ooc8cyLDa5wQFY0ahYyiQgYnOLIS5XSgMtOpBqdxykhFwqkGnBWL/xlcJhYE1++gnosoq1HBU1MTakhqiVHHUUMGeP1SaFS6vX4awNc7RFhqRqDW9RPxifhEvPNH9OuXRTAq6Rs1ozTqCGrIvcGTnCjo161D+h24nLHUnhoHFBuEpU58LOrQJlBXLCQOLTHQM7AwCzKkEazomW5X/+duvHP31+s1vy/9BaXINz/IBBwEAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactless);
export default __webpack_public_path__ + "static/media/contactless.4f3a307adcc6ef5e68579b0f5b3a2d28.svg";
export { ForwardRef as ReactComponent };